module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/chronicDisease/ChronicDisseDetailsHead.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FchronicDisease%2FChronicDisseDetailsHead.jpg
// module id = 0dba
// module chunks = 93